<template>
  <div class="withdraw">
    <Row type="flex" justify="center">
      <Col :span="16">
        <Row type="flex" justify="center">
          <Col :span="24">
            <div :span="24" style="background:#ddd;font-size:30px;border-radius:5px;">选择充值方式</div>
            <div class="box">
              <div style="margin-bottom:20px;font-size:20px;">充值银行</div>
              <Row type="flex">
                <Col :span="6" v-for="(item,i) in cardList" :key="i">
                  <div class="bank_card_box">
                    <div class="bank_name" v-model="form.bankid"  @click="unbounding(item,i)">
                      <img :src="item.bankImgUrl|imgSrc1" v-bind:class="{bandColor1:true,bandColor2:rowNo===i?true:false}">
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        <div class="box">
          <div style="font-size:20px;margin-bottom:20px;">填写充值金额</div>
          <Form ref="form" :model="form" :rules="rule" :label-width="180">
            <FormItem label="账户余额：">
              <span class="large_font">{{balance | moneyFilter}}</span>元
            </FormItem>
            <FormItem label="充值金额：" prop="amount">
              <Input v-model="form.amount"></Input>
            </FormItem>
            <FormItem label="实际到账金额：">
              <span class="large_font">{{computedAmount|moneyFilter}}</span>元
            </FormItem>
            <P>温馨提示</P>
            <P>1、为了您的账户安全，请在充值前进行身份认证、手机绑定以及提现密码设置。</P>
            <P>2、您的账户资金将通过第三方平台进行充值。</P>
            <P>3、请注意您的银行卡充值限制，以免造成不便。</P>
            <P>4、禁止洗钱，信用卡套现、虚假交易等行为，一经发现并确认，将终止该账户的使用。</P>
            <P>5、如果充值金额没有及时到账，请联系客服。</P>
          </Form>
        </div>
        <div class="b_button_group">
          <my-button @confirm="() => {this.$router.go(-1)}">返回</my-button>
          <my-button @click.native="onSubmit('form')">充值</my-button>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
  import ApiClient from '@/api/ApiClient'
  import MyButton from '@/components/MyButton'
  export default {
    components: {MyButton},
    name: 'recharge',
    data() {
      return {
        cardList: [],
        balance: null,
        rowNo:'',
        card: {
          id:'',
          bankName: '',
          cardNo: ''
        },
        cardDialog: false,
        form: {
          bankid:'',
          amount: '',
        },
        rule: {
          amount: [
            {pattern: '^[0-9]+(.[0-9]{1,2})?$', required: true, message: '请输入数字', trigger: 'blur'}
          ]
        },
        serviceCharge:null
      }
    },
    methods: {
      initData() {
        ApiClient.get('/commons/brokerage.do').then(data=>{
            this.serviceCharge = data;
          }
        )
        ApiClient.post('/desktop/profile/webCardQuery.do', {size: 9999, page: 1}, {silent: true}).then(data => {
          this.cardList = data.wWebCardQueryDataDtoList
        })
        ApiClient.get('/desktop/profile/balance.do').then(data => {
          this.balance = data.toFixed(2);
        });
       },
      chooseCard() {
        this.cardDialog = true
      },
      onSubmit() {
        if(this.rowNo ===''){
          this.$Message.error('请选择银行卡')
          return;
        }
        if (this.form.amount < 0||this.form.amount ==='') {
          this.$Message.error('充值金额必须大于零')
          return;
        }
        ApiClient.post('/desktop/profile/webCardRecharge.do',this.form).then(data=>{
          console.log(data.url);
          this.url = data.url;
          window.open(this.url,'_blank')
        })
      },
      password(value) {
        this.form.cashPassword = value;
      },
      unbounding(item,i) {
        this.form.bankid=item.id;
        this.rowNo = i;
      },
    },
    computed:{
      computedAmount(){
        if(this.form.amount>0){
          return `${Number(this.form.amount - 0).toFixed(2)}`
        }else{
          return '0.00'
        }
      }
    },
    mounted() {
      this.initData()
    },
  }
</script>
<style scoped lang="less">
  .box {
    border: 1px solid #999;
    border-radius: 5px;
    padding: 40px 80px;
    margin-bottom: 20px;
    overflow: hidden;
    .large_font{
      font-size: 16px;
    }
    .box_left {
      float: left;
    }
    .box_right {
      float: right;
      cursor: pointer;
      margin:16px 0;
    }
    .bank_name {
      margin-bottom: 20px;
      font-size: 25px;
      display: flex;
      justify-content: center;
    }
    .card_no {
      font-size: 15px
    }
    .bandColor1{
      border:3px solid #ddd;
      margin: 0 auto;
      display: block;
    }
     .bandColor2{
       border:3px solid #228b22;
     }
  }


</style>
<style lang="less">
  .input {
    display: inline-block;
    &:last-child {
      border-right: 1px solid #999;
    }
    input {
      border-top: 1px solid #999;
      border-bottom: 1px solid #999;
      border-left: 1px solid #999;
      width: 45px;
      height: 45px;
      outline: none;
      font-family: inherit;
      font-size: 28px;
      font-weight: inherit;
      text-align: center;
      line-height: 45px;
      color: #c2c2c2;
      background: rgba(255, 255, 255, 0);
    }
  }
  .withdraw .ivu-form-item-label{
    font-size: 14px!important;
  }

</style>



// WEBPACK FOOTER //
// src/pages/myProfile/recharge.vue